import { useId } from 'react';

export const usePlateId = (id?: string) => {
  const randomId = useId();

  return id ?? randomId;
};
